// src/hooks/useCaseHistoryEnabled.js
import { useEffect, useState } from 'react';
import api from '../services/api';

// One status request per page load, shared by every component that asks.
let statusRequest = null;

export function fetchCaseHistoryEnabled() {
  if (!statusRequest) {
    statusRequest = api.get('/case-history/status')
      .then((res) => res.data?.enabled === true)
      .catch(() => {
        // Backend without the endpoint, or offline: treat as off, retry next time.
        statusRequest = null;
        return false;
      });
  }
  return statusRequest;
}

/**
 * Whether the Case History feature is switched on (backend CASE_HISTORY_ENABLED).
 * `enabled` stays false until the backend confirms; guards should wait for `loading`.
 */
export default function useCaseHistoryEnabled() {
  const [state, setState] = useState({ enabled: false, loading: true });

  useEffect(() => {
    let mounted = true;
    fetchCaseHistoryEnabled().then((enabled) => {
      if (mounted) setState({ enabled, loading: false });
    });
    return () => {
      mounted = false;
    };
  }, []);

  return state;
}
